import { injectable } from 'inversify';
import { getNotes, getVOMSQuestionFromSpecs } from '../modules.helper';
import vomsSpecs from './voms_v1.0.json';
import { AssessmentCreationViewService } from '../../../assessmentCreationView/assessmentCreation.view.service';
import { Label } from '../modules.interface';

export interface KeyValue {
  key: string;
  value: string;
}

export interface Question {
  rowId: string;
  key: string;
  label: string;
  headache: number;
  dizziness: number;
  nausea: number;
  fogginess: number;
  comment: string;
  convergenceNearPointMeasurement1: number;
  convergenceNearPointMeasurement2: number;
  convergenceNearPointMeasurement3: number;
  notTested: boolean;
}

// TODO Use this type for Response and figure out the errors
export type Response = {
  [key in keyof Question]: string | boolean;
};

interface DumbConfig {
  title: string;
  headerLabels: KeyValue[];
  vomsBaselineSymptomsQuestion: Question;
  vomsSmoothPursuitsQuestion: Question;
  vomsSaccadesHorizontalQuestion: Question;
  vomsSaccadesVerticalQuestion: Question;
  vomsConvergenceQuestion: Question;
  vomsVORHorizontalQuestion: Question;
  vomsVORVerticalQuestion: Question;
  vomsVisualMotionSensitivityTestQuestion: Question;
  note: Label;
}

@injectable()
export class VomsDomainService {
  public constructor(
    private assessmentCreationViewService: AssessmentCreationViewService,
  ) {}
  dumbConfig = (): DumbConfig => {
    return {
      title: vomsSpecs.titles[0].l10nKey,
      headerLabels: vomsSpecs.vomsColumnHeaderLabels,
      vomsBaselineSymptomsQuestion: getVOMSQuestionFromSpecs(
        vomsSpecs.assessment.vomsBaselineSymptoms,
      ),
      vomsSmoothPursuitsQuestion: getVOMSQuestionFromSpecs(
        vomsSpecs.assessment.vomsSmoothPursuits,
      ),
      vomsSaccadesHorizontalQuestion: getVOMSQuestionFromSpecs(
        vomsSpecs.assessment.vomsSaccadesHorizontal,
      ),
      vomsSaccadesVerticalQuestion: getVOMSQuestionFromSpecs(
        vomsSpecs.assessment.vomsSaccadesVertical,
      ),
      vomsConvergenceQuestion: getVOMSQuestionFromSpecs(
        vomsSpecs.assessment.vomsConvergence,
      ),
      vomsVORHorizontalQuestion: getVOMSQuestionFromSpecs(
        vomsSpecs.assessment.vomsVORHorizontal,
      ),
      vomsVORVerticalQuestion: getVOMSQuestionFromSpecs(
        vomsSpecs.assessment.vomsVORVertical,
      ),
      vomsVisualMotionSensitivityTestQuestion: getVOMSQuestionFromSpecs(
        vomsSpecs.assessment.vomsVisualMotionSensitivityTest,
      ),
      note: getNotes(vomsSpecs.assessment.values),
    };
  };

  resetSkipModule(moduleName: string): void {
    this.assessmentCreationViewService.dispatchSetAssessmentModuleDetails(
      moduleName,
      'skipModuleFlag',
      false,
    );

    this.assessmentCreationViewService.dispatchSetAssessmentModuleDetails(
      moduleName,
      'skipModuleComments',
      '',
    );
  }
}
